/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdImageProps } from './type';

export const imageDefaultProps: TdImageProps = {
  fit: 'fill',
  gallery: false,
  lazy: false,
  overlayTrigger: 'always',
  position: 'center',
  shape: 'square',
};
